// «Construye tu arquitectura»: a partir de unas pocas decisiones arma el diagrama de una tienda en linea y revisa sus puntos debiles.
export const OPCIONES_DEFECTO = { waf: false, cdn: false, balanceador: false, servidores: 1, zonas: 1, base: "una", cache: false, archivos: false, respaldos: false };

const NIVEL = { alto: { texto: "Riesgo alto", resta: 25 }, medio: { texto: "A mejorar", resta: 12 }, info: { texto: "Sugerencia", resta: 4 }, ok: { texto: "Bien", resta: 0 } };
export const NIVELES_AVISO = NIVEL;

export const armar = (o) => {
    o = { ...OPCIONES_DEFECTO, ...o };
    const cols = [];
    cols.push([{ k: "clientes", l: "Clientes", g: "personas" }]);
    if (o.waf) cols.push([{ k: "waf", l: "WAF", g: "escudo" }]);
    if (o.cdn) cols.push([{ k: "cdn", l: "CloudFront", g: "nube" }]);
    if (o.balanceador) cols.push([{ k: "lb", l: "Balanceador", g: "balanza" }]);
    const serv = [];
    for (let i = 0; i < o.servidores; i++) {
        const zona = o.zonas === 2 ? (i % 2 === 0 ? "A" : "B") : null;
        serv.push({ k: `s${i}`, l: zona ? `Servidor ${zona}${Math.floor(i / 2) + 1}` : `Servidor ${i + 1}`, g: "servidor", zona });
    }
    cols.push(serv);
    const lateral = [];
    if (o.cache) lateral.push({ k: "cache", l: "Caché", g: "archivo" });
    if (o.archivos) lateral.push({ k: "s3", l: "Archivos (S3)", g: "carpeta" });
    if (lateral.length) cols.push(lateral);
    const hayBase = o.base !== "ninguna";
    if (hayBase) {
        const bd = [{ k: "db", l: o.base === "replica" ? "Base primaria" : "Base de datos", g: "datos", zona: o.zonas === 2 ? "A" : null }];
        if (o.base === "replica") bd.push({ k: "dbr", l: "Réplica", g: "datos", zona: o.zonas === 2 ? "B" : null });
        cols.push(bd);
    }
    if (o.respaldos && hayBase) cols.push([{ k: "bk", l: "Respaldos", g: "reloj" }]);

    // posiciones
    const nodos = [];
    const indice = {};
    cols.forEach((col, ci) => {
        const x = cols.length === 1 ? 400 : 60 + (ci * 680) / (cols.length - 1);
        const gap = col.length === 1 ? 0 : col.length === 2 ? 120 : 105;
        col.forEach((it, j) => {
            indice[it.k] = nodos.length;
            nodos.push([it.l, it.g, Math.round(x), Math.round(170 + (j - (col.length - 1) / 2) * gap)]);
            it.col = ci;
        });
    });

    // flechas: clientes -> [WAF] -> [CDN] -> [balanceador] -> servidores; los servidores alimentan a la cache, a los archivos y a la base;
    // la base primaria copia a la replica y a los respaldos. El numero de paso sigue el orden del recorrido.
    const cadena = cols.filter(c => c !== serv && !c.some(x => ["cache", "s3", "db", "dbr", "bk"].includes(x.k)));
    const crudos = [];
    const unir = (de, a, paso) => crudos.push([indice[de], indice[a], paso]);
    cadena.forEach((col, ci) => {
        const sig = ci + 1 < cadena.length ? cadena[ci + 1] : serv;
        col.forEach(a => sig.forEach(b => unir(a.k, b.k, ci)));
    });
    const pasoServ = cadena.length;
    serv.forEach(sv => {
        lateral.forEach(l => unir(sv.k, l.k, pasoServ));
        if (hayBase) unir(sv.k, "db", pasoServ);
    });
    if (hayBase) {
        if (o.base === "replica") unir("db", "dbr", pasoServ + 1);
        if (o.respaldos) unir("db", "bk", pasoServ + 1);
    }
    const flujos = crudos;

    // recuadros por zona
    const grupos = [];
    ["A", "B"].forEach(z => {
        const idx = cols.flat().filter(it => it.zona === z).map(it => indice[it.k]);
        if (o.zonas === 2 && idx.length) grupos.push({ idx, etiqueta: `Zona ${z}` });
    });

    // revision
    const avisos = [];
    const a = (nivel, texto) => avisos.push({ nivel, texto });
    if (o.servidores === 1 && !o.balanceador) a("alto", "Hay un solo servidor: si falla, la tienda se cae por completo (punto único de falla).");
    if (o.servidores > 1 && !o.balanceador) a("medio", "Tienes varios servidores, pero nada reparte a los clientes entre ellos. Agrega un balanceador.");
    if (o.balanceador && o.servidores === 1) a("medio", "El balanceador no ayuda con un solo servidor: agrega otro para que tenga entre quiénes repartir.");
    if (o.zonas === 1) a("medio", "Todo está en una sola zona de disponibilidad: si falla ese edificio, se cae todo.");
    if (o.zonas === 2 && o.servidores === 1) a("medio", "Pediste dos zonas, pero con un solo servidor la segunda zona queda vacía: agrega otro servidor.");
    if (o.base === "ninguna") a("medio", "Sin base de datos no se pueden guardar pedidos ni clientes.");
    if (o.base === "una") a("alto", "La base de datos es un punto único de falla: si cae, no se pueden tomar pedidos.");
    if (o.base === "replica" && o.zonas === 1) a("medio", "La réplica está en la misma zona: protege de la falla de un equipo, pero no de la caída de toda la zona.");
    if (hayBase && !o.respaldos) a("medio", "Sin respaldos, un error o un ataque podría borrar todo sin vuelta atrás.");
    if (!o.waf) a("info", "Sin WAF, los ataques web comunes llegan directo a tus servidores.");
    if (o.archivos && !o.cdn) a("info", "Las fotos se entregan desde un solo lugar: una CDN (CloudFront) las acerca a cada cliente.");
    if (!o.cache && hayBase) a("info", "Sin caché, la base responde cada vez lo mismo; con mucho tráfico se vuelve lenta.");
    if (o.balanceador && o.servidores > 1 && o.zonas === 2) a("ok", "Si cae una zona, el balanceador manda todo a la otra y la tienda sigue abierta.");
    if (o.base === "replica" && o.zonas === 2) a("ok", "La base tiene una copia en otra zona: toma el mando si la principal falla.");
    if (o.respaldos && hayBase) a("ok", "Hay respaldos: se puede volver atrás ante un error.");
    if (o.waf) a("ok", "El WAF frena los ataques web más comunes antes de que lleguen a tus servidores.");
    if (o.cdn) a("ok", "La CDN acerca el contenido a los clientes y alivia a tus servidores.");
    if (o.cache && hayBase) a("ok", "La caché responde lo repetido al instante y descansa a la base de datos.");
    const puntaje = Math.max(0, 100 - avisos.reduce((s, x) => s + NIVEL[x.nivel].resta, 0));
    return { nodos, flujos, grupos, avisos, puntaje };
};
